module.exports = __webpack_public_path__ + "img/t4-i9.ca63e60e.jpg";